export default __webpack_public_path__ + "static/media/DesktopTopImage.a9c0fd24.jpg";